import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../client/firebase/auth';
import { updateUser } from '../../redux/actions/authActions';
import LogoutIcon from '../../assets/images/logout.svg';

const Logout = ({ setUser }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
      setUser(null);
    } catch (error) {
      console.error(error);
      alert(error.message);
    }
  };

  return (
    <button
      onClick={handleLogout}
      className="flex justify-between items-center w-[105px] p-3 hover:opacity-80 hover:bg-mist-gray cursor-pointer"
    >
      <img src={LogoutIcon} className="w-5 h-5" alt="Logout icon" />
      <span className="text-sm font-semibold text-wave-blue">Logout</span>
    </button>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setUser: (user) => dispatch(updateUser(user)),
});

export default connect(null, mapDispatchToProps)(Logout);
